import { render, staticRenderFns } from "./HistoricoEntregas.vue?vue&type=template&id=19456d8d"
import script from "./HistoricoEntregas.vue?vue&type=script&lang=js"
export * from "./HistoricoEntregas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports